<template>
  <v-card>
    <v-card-title class="headline grey lighten-2">
      Add new feature</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" sm="6">
          <label for class="fz-10px">Title</label>
          <div class="position-relative">
            <input v-model="title" v-validate="'required'" class="form-control" name="title" placeholder="Enter Title" />
            <span class="text-danger">{{ errors.first("title") }}</span>
          </div>
        </v-col>
        <v-col cols="12" md="6" sm="6" class="d-none d-md-block">
          <!-- <label for class="fz-10px">Title</label>
          <div class="position-relative">
            <input
              class="form-control"
              placeholder="Enter Title"
            />
          </div> -->
        </v-col>

        <v-col cols="12" md="6" sm="6">
          <label for class="fz-10px">Redirect to (URL)</label>
          <div class="position-relative">
            <input v-model="redirect_url" class="form-control" placeholder="Url" />
          </div>
        </v-col>
        <v-col cols="12" md="6" sm="6">
            <label for>Roles</label>
            <v-select v-model="role" v-validate="'required'"  :items="roles" placeholder="Select Roles" required name="role" outlined
              hide-details multiple>
              <template v-slot:prepend-item>
                        <v-checkbox
                          class="px-3"
                          @mousedown.prevent
                          @change="role_type_toggle"
                          v-model="roleTypeSelectAll"
                          :label="'Select All'"
                          hide-details
                        ></v-checkbox>
                      </template>
            </v-select>
              <span class="text-danger">{{ errors.first("role") }}</span>

          </v-col>
        <v-col cols="12" md="12" sm="6">
          <label for>Description</label>
          <v-textarea v-model="description" v-validate="'required'" outlined hide-details name="description" placeholder="Description"></v-textarea>
            <span class="text-danger">{{ errors.first("description") }}</span>

        </v-col>
        <v-col cols="12" md="6" sm="6" class="csv-input-box csv-no-file">
          <label for>Upload image</label>
          <p v-if="uploadedImgFullUrl.length < 1" class="choosen-label position-absolute">No File Selected</p>
          <!-- <span class="selected-label position-absolute">dfss</span> -->
          <!-- <input
              type="file"
              class="border-radius custom-file-input"
            /> -->
          <file-upload :media="'image'" :accept="accepted" label="upload" :src="docLink" :refName="'upload7098'"
            :role="'patient'" :multiple="false" :module="'referred'" :drop="true" @uploaded="fileUploaded"
            :uploadFileToServer="true" :uploadedImg="uploadedImg"></file-upload>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="$emit('close')">Cancel</v-btn>
      <v-btn color="success" @click="addFeature()">Submit</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import FileUpload from "@/components/FileUpload.vue";
export default {
  $_veeValidate: {
    validator: "new"
  },
  props: ["feature"],
  data() {
    return {
      accepted: "image/png,image/jpg,image/jpeg",
      roles: ["Patient", "Doctor", "Pharmacy", "Diagnostics-lab", "Ambulance", "BloodBank","Hospital"],
      title: "",
      redirect_url: "",
      role: [],
      description: '',
      docLink: null,
      uploadedImg: [],
      uploadedImgFullUrl: [],
      roleTypeSelectAll: false,
    }
  },
  components: {
    FileUpload,
  },
  watch: {
    role(val) {
      if(this.roles.length === val.length){
         this.roleTypeSelectAll = true;
      }
      else{
        this.roleTypeSelectAll = false;
      }
      }
    },
  computed:{
    likesRole() {
      return (
        this.role.length === this.roles.length
      );
    },
  },
  mounted() {
    if (this.feature && this.feature.title) {
      this.title = this.feature.title
      this.redirect_url = this.feature.redirect_url
      this.role = this.feature.roles
      this.description = this.feature.description
    }
  },
  methods: {
    role_type_toggle(){
      this.$nextTick(() => {
        if(this.likesRole){
          this.role =[];
        }
        else{
          this.role = this.roles.slice();
        }
      })
    },
    //   showImage(img) {
    //   const imageUrl = this.uploadedImgFullUrl.find(el => el.includes(img));
    //   this.openModal(imageUrl, "image");
    // },
    // openModal(fileUrl, fileArcheType) {
    //   this.fileUrl = fileUrl;
    //   this.fileArcheType = fileArcheType;
    //   this.openImageModal = true;
    // },
    addFeature() {

      this.$validator.validate().then(valid => {
        if (valid) {
          let feature =
          {
            image_url: this.uploadedImgFullUrl,
            redirect_url: this.redirect_url,
            roles: this.role,
            title: this.title,
            description: this.description,
            is_deleted: false
          }
          this.$emit('addNewFeature', feature)
        }
      });

    },
    fileUploaded(files, uploaded, name) {
      this.showLoader = true;
      if (uploaded) {
        this.uploadedImgFullUrl = files;
        this.uploadedImg = files.map(el => {
          return el.split("/").pop();
        });

        this.showLoader = false;
      }
    },

    // delete iamge method
    // deleteImg() {
    //   this.uploadedImg = [];
    //   this.uploadedImgFullUrl = [];
    // },

  }
}
</script>
